export const APP_URL_PREFIX = '/travel-ss';

export const PAGE_INDICES = {
    LANDING_PAGE: -1,
    QUOTE: 0,
    TRAVEL_DETAILS: 1,
    NEXT_OF_KIN: 2,
    PAYMENT: 3,
};

export const PAGES = [
    {
        URL: `${APP_URL_PREFIX}/get-quote`,
        URL_PART: 'get-quote',
        TITLE: 'Get Quote',
    },
    {
        URL: `${APP_URL_PREFIX}/details`,
        URL_PART: 'travel-details',
        TITLE: 'Travel Details',
    },
    {
        URL: `${APP_URL_PREFIX}/next-of-kin`,
        URL_PART: 'next-of-kin',
        TITLE: 'Next Of Kin',
    },

    {
        URL: `${APP_URL_PREFIX}/payment`,
        URL_PART: 'payment',
        TITLE: 'Payment',
    },
];

export const COVER_PLANS = {
    SILVER_COVER: {
        title: 'Holiday',
        value: 'Holiday',
        imageUrl:
            'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt37875ee1779db977/67b72ab2abe3fd907169b387/Retirement.png',
    },
    SCHENGEN_COVER: {
        title: 'Schengen',
        value: 'Schengen',
        imageUrl:
            'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/bltfb5f3f55462a0e31/67b72c2ed8d35d75b1c39a49/Rewards.png',
    },
    SENIOR_COVER: {
        title: 'Senior',
        value: 'Senior',
        imageUrl:
            'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt75b71c6dd9b95598/67b72aeeb3ac030e34417ae0/Single_Neutral_Actions_Add.png',
    },
    EA_COVER: {
        title: 'E.Africa',
        value: 'East Africa',
        imageUrl:
            'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt720cf6c41f611fb6/67b72bcf92e36fbb367b6f25/Travel.png',
    },
};

export const TOGGLE_STATUS = {
    YES: true,
    NO: false,
    UNTOUCHED: 'untouched',
};

export const TRAVEL_INSURANCE_URLS = {
    QUOTE: PAGES[PAGE_INDICES.QUOTE].URL,
    TRAVEL_DETAILS: PAGES[PAGE_INDICES.TRAVEL_DETAILS].URL,
    NEXT_OF_KIN: PAGES[PAGE_INDICES.NEXT_OF_KIN].URL,
    PAYMENT: PAGES[PAGE_INDICES.PAYMENT].URL,
};
